import React, { useState } from "react";

import { cloneDeep } from "lodash";

import "./filter-chips.css";

export default function FilterChips({
  onChange = () => {},
  isMultiSelect = false,
  tags,
  setTags,
}) {
  const hasTags = !!tags && Array.isArray(tags) && tags.length > 0;
  return (
    <div className="filter-chips">
      {hasTags &&
        tags.map((tag) => {
          return (
            <button
              className={`filter-chips__chip ${tag.active ? "active" : ""}`}
              onClick={() => {
                if (!isMultiSelect) {
                  let updatedTags = cloneDeep(tags);

                  //verificando se a tag estava ativa
                  const isActive = tag.active;

                  //desativando todas as tags
                  updatedTags.forEach((updatedTag) => {
                    updatedTag.active = false;
                  });

                  //se a tag não estava ativa antes do clique nós ativamos ela
                  if (!isActive) {
                    updatedTags.forEach((updatedTag) => {
                      const isThisTag = updatedTag.id === tag.id;
                      if (isThisTag) {
                        updatedTag.active = true;
                      }
                    });
                  }

                  // atualizando as tags
                  setTags(updatedTags);

                  //enviando a tag ativada ou enviando uma array vazia no caso de todas desativadas
                  const activesTags = updatedTags.filter((updatedTag) => {
                    return updatedTag.active;
                  });
                  const isToActiveAll = isActive;
                  onChange(activesTags, updatedTags, isToActiveAll);
                } else {
                  let updatedTags = cloneDeep(tags);

                  //verificando se a tag estava ativa
                  const isActive = tag.active;

                  //se a tag não estava ativa antes do clique nós ativamos ela
                  if (!isActive) {
                    updatedTags.forEach((updatedTag) => {
                      const isThisTag = updatedTag.id === tag.id;
                      if (isThisTag) {
                        updatedTag.active = true;
                      }
                    });
                  } else {
                    updatedTags.forEach((updatedTag) => {
                      const isThisTag = updatedTag.id === tag.id;
                      if (isThisTag) {
                        updatedTag.active = false;
                      }
                    });
                  }

                  setTags(updatedTags);
                  //enviando a tag ativada ou enviando uma array vazia no caso de todas desativadas
                  const activesTags = updatedTags.filter((updatedTag) => {
                    return updatedTag.active;
                  });
                  onChange(activesTags, updatedTags);
                }
              }}
            >
              {tag.label}
            </button>
          );
        })}
    </div>
  );
}
